import React from 'react';
import { Row, Col, Thumbnail } from 'react-bootstrap';

const GradesList = ({ grades, onSelect }) => (<Row style={{	display: 'flex', flexWrap: 'wrap' }}>
	{grades.map(grade => <Col xs={6} md={4} key={grade.id} style={{ display: 'flex', flexDirection: 'column' }}>
		<a onClick={() => onSelect(grade)} style={{ cursor: 'pointer' }}>
			<Thumbnail src={grade.imageUrl} style={{ textAlign: 'center' }}>
				<h3>{grade.name}</h3>
				{grade.attendingChildren && <div>{grade.attendingChildren.map(child => child.shortName).join(', ')}</div>}
			</Thumbnail>
		</a>
	</Col>)}
</Row>);

export default GradesList;